import { Handle, Position } from '@xyflow/react';

import { cn } from '@/utils/classname';

interface NodeHandlesProps {
  isEditMode: boolean;
}

/**
 * Reusable handle set for attack path nodes.
 * Left target + right source for clean LR flow.
 */
export function NodeHandles({ isEditMode }: NodeHandlesProps) {
  const handleClass = cn(
    'bg-chariot-text-primary size-3 border-none',
    !isEditMode && 'invisible'
  );

  return (
    <>
      <Handle className={handleClass} type="target" position={Position.Left} />
      <Handle className={handleClass} type="source" position={Position.Right} />
    </>
  );
}
